import React, { Component } from "react";
import styles from "./index.module.less";
import { DarkModal } from "@/components/Modal";
import darkControl from "@/components/Modal/darkControl.module.less";
import { Radio, AutoComplete, Button } from "antd";
import UnitTypeTree from "./UnitTypeTree";
import UnitTree from "./UnitTree";
import http from "@/http";
import { connect } from "dva";
import debounce from "lodash.debounce";
const HttpUnit = http.tokiot.sys.unit.v2;

@connect(({ commonModel }) => ({ selectUnit: commonModel.selectUnit }))
class unitSelectModal extends Component {
  state = {
    unitListByType: [],
    showUnitListByType: [],
    unitList: [],
    showUnitList: [],
    treeKey: 0,
    treeType: 1,
    filterText: ``,
    selectUnit: undefined,
  };

  componentDidMount() {
    this.loadUnitListByType();
    this.loadUnitList();
    this.setState({ selectUnit: this.props.selectUnit });
    this.autoCompleteChange = debounce(this.bindAutoCompleteChange, 500);
  }

  loadUnitListByType = () => {
    HttpUnit.listCategoryUnit({}).then((unitListByType) => {
      if (unitListByType) {
        this.setState({
          showUnitListByType: unitListByType,
          unitListByType,
          treeKey: this.state.treeKey + 1,
        });
      }
    });
  };

  loadUnitList = () => {
    HttpUnit.tree({}).then((unitList) => {
      this.listProcess(unitList);
      this.setState({
        showUnitList: unitList,
        unitList,
        treeKey: this.state.treeKey + 1,
      });
    });
  };
  listProcess = (unit) => {
    unit.organsCount = 0;
    unit.unitCount = 0;
    if (unit.type === `Organs`) {
      if (unit.childrenList && unit.childrenList.length > 0) {
        unit.childrenList.sort((f1, f2) => {
          if (f1.type === `Organs` && f2.type === `Unit`) {
            return -1;
          } else if (f2.type === `Organs` && f1.type === `Unit`) {
            return 1;
          } else {
            return 0;
          }
        });
        unit.childrenList.forEach((f1) => {
          switch (f1.type) {
            case `Organs`:
              unit.organsCount++;
              break;
            case `Unit`:
              unit.unitCount++;
              break;
            default:
              break;
          }
        });
        unit.childrenList.forEach((item) => this.listProcess(item));
      }
    }
  };
  handleSubmit = (e) => {
    const { selectUnit } = this.state;
    const { onClose } = this.props;
    this.props.dispatch({
      type: "commonModel/selectUnit",
      payload: selectUnit,
    });
    onClose && onClose();
  };
  resetUnit = (e) => {
    const { onClose } = this.props;
    this.props.dispatch({ type: "commonModel/selectUnit", payload: undefined });
    onClose && onClose();
  };

  treeSelect = (selectedKeys, e) => {
    if (e.node.props.treeType === `unit`) {
      this.setState({ selectUnit: e.node.props.dataRef });
    }
  };
  treeTypeChange = (e) => {
    this.setState({ treeType: e.target.value });
  };

  changeAutoComplete = (filterText) => {
    this.autoCompleteChange(filterText);
    this.setState({ filterText });
  };

  bindAutoCompleteChange = (filterText) => {
    const { unitListByType, unitList } = this.state;
    if (filterText && filterText.length > 0) {
      let units = JSON.parse(JSON.stringify(unitListByType));
      let showUnitListByType = this.filterUnitListByType(units, filterText);
      units = JSON.parse(JSON.stringify(unitList));
      let showUnitList = this.filterUnitList([units], filterText);
      if (showUnitList && showUnitList.length > 0) {
        showUnitList = showUnitList[0];
        this.listProcess(showUnitList);
      }
      this.setState({ showUnitListByType, showUnitList });
    } else {
      this.setState({
        showUnitListByType: unitListByType,
        showUnitList: unitList,
      });
    }
  };

  filterUnitListByType = (data, filterText) => {
    let showUnitListByType = [];
    if (data && data.length > 0) {
      data.forEach((item) => {
        if (item.unitList && item.unitList.length > 0) {
          item.unitList = item.unitList.filter((unit) => {
            return unit.name && unit.name.indexOf(filterText) >= 0;
          });
        }
        if (item.unitList && item.unitList.length > 0) {
          showUnitListByType.push(item);
        }
      });
    }
    return showUnitListByType;
  };

  filterUnitList = (data, filterText) => {
    if (data && data.length > 0) {
      data.forEach((item) => {
        if (item.childrenList && item.childrenList.length > 0) {
          item.childrenList = this.filterUnitList(
            item.childrenList,
            filterText
          );
        }
      });
      data = data.filter((unit) => {
        return (
          (unit.name && unit.name.indexOf(filterText) >= 0) ||
          (unit.childrenList && unit.childrenList.length > 0)
        );
      });
    }
    return data;
  };

  render() {
    const {
      showUnitListByType,
      showUnitList,
      treeKey,
      treeType,
      filterText,
      selectUnit,
    } = this.state;
    const { visible, onClose } = this.props;

    let footer = (
      <div className={styles.footButtonDiv}>
        <Button className={styles.button} onClick={this.resetUnit}>
          重置
        </Button>
        <Button
          type="primary"
          className={styles.button}
          onClick={this.handleSubmit}
        >
          确定
        </Button>
      </div>
    );
    let title = selectUnit ? ` - ${selectUnit.name}` : ``;
    let modalProps = {
      className: darkControl.darkControl,
      title: "单位选择" + title,
      centered: true,
      visible,
      width: `6rem`,
      maskClosable: false,
      onCancel: onClose,
      onOk: this.handleSubmit,
      footer,
    };
    return (
      <DarkModal {...modalProps}>
        <div className={styles.main}>
          <div className={styles.title}>
            <div className={styles.autoCompleteDiv}>
              <AutoComplete
                className={styles.autoComplete}
                allowClear
                placeholder="搜索（请输入企业名称）"
                onChange={this.changeAutoComplete}
                value={filterText}
              />
            </div>
            <div className={styles.radioDiv}>
              <Radio.Group onChange={this.treeTypeChange} value={treeType}>
                <Radio value={1}>机构单位</Radio>
                <Radio value={2}>单位类型</Radio>
              </Radio.Group>
            </div>
          </div>
          <div className={styles.body}>
            {treeType === 2 ? (
              <UnitTypeTree
                onSelect={this.treeSelect}
                key={treeKey}
                data={showUnitListByType}
                value={selectUnit}
              />
            ) : (
              <UnitTree
                onSelect={this.treeSelect}
                key={treeKey}
                data={showUnitList}
                value={selectUnit}
              />
            )}
          </div>
        </div>
      </DarkModal>
    );
  }
}
export default unitSelectModal;
